import { useDrag, useDrop } from 'react-dnd';
import { useRef } from 'react';

const ItemType = 'ITEM_CARD';

export default function DraggableItemCard({ index, item, moveItem, children }) {
  const cardRef = useRef(null);
  const handleRef = useRef(null);

  const [, drop] = useDrop({
    accept: ItemType,
    hover(draggedItem, monitor) {
      if (!cardRef.current) return;
      if (draggedItem.index === index) return;

      const hoverBoundingRect = cardRef.current.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      if (!clientOffset) return;

      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      if (draggedItem.index < index && hoverClientY < hoverMiddleY) return;
      if (draggedItem.index > index && hoverClientY > hoverMiddleY) return;

      moveItem(draggedItem.index, index);
      draggedItem.index = index;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: ItemType,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(handleRef);
  drop(cardRef);

  return (
    <div
      ref={cardRef}
      style={{
        opacity: isDragging ? 0.5 : 1,
        marginBottom: '12px',
      }}
    >
      <div
        ref={handleRef}
        role="button"
        tabIndex={0}
        aria-label="Drag to reorder challenge"
        title="Drag to reorder"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          marginBottom: '6px',
          padding: '4px 8px',
          borderRadius: '6px',
          border: '1px solid rgba(15, 23, 42, 0.12)',
          backgroundColor: '#f8fafc',
          color: '#64748b',
          fontSize: '12px',
          fontWeight: 600,
          cursor: 'grab',
          userSelect: 'none',
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
          }
        }}
      >
        <span aria-hidden="true" style={{ letterSpacing: '2px', lineHeight: 1 }}>
          ⋮⋮
        </span>
        Drag to reorder
      </div>
      {children}
    </div>
  );
}
